/* Collection Bubbles - behaviour for the story-bubble collection rail.

   Everything visible is rendered by sections/collection-bubbles.liquid. This
   file only adds the parts that cannot be done in Liquid: the arrows, and the
   "already visited" state, which is per shopper and therefore has to be
   applied in the browser rather than baked into cached page HTML. */

(() => {
  const STORE_KEY = "collection-bubbles:viewed";

  /* localStorage can throw outright in private mode / with cookies blocked, so
     every read and write is guarded. A failure just means no viewed state. */
  function readViewed() {
    try {
      const raw = window.localStorage.getItem(STORE_KEY);
      return raw ? new Set(JSON.parse(raw)) : new Set();
    } catch (e) {
      return new Set();
    }
  }

  function markViewed(handle) {
    try {
      const seen = readViewed();
      seen.add(handle);
      window.localStorage.setItem(STORE_KEY, JSON.stringify([...seen]));
    } catch (e) {
      /* no-op */
    }
  }

  class CollectionBubbles extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector("[data-bubbles-list]");
      if (!this.list) return;

      this.updateEdge = this.updateEdge.bind(this);
      this.list.addEventListener("scroll", this.updateEdge, { passive: true });
      window.addEventListener("resize", this.updateEdge);
      this.updateEdge();

      const prev = this.querySelector("[data-bubbles-prev]");
      const next = this.querySelector("[data-bubbles-next]");
      if (prev) prev.addEventListener("click", () => this.page(-1));
      if (next) next.addEventListener("click", () => this.page(1));

      this.restoreViewed();

      /* Mark as viewed on tap and remember it. This intentionally does not
         call preventDefault, so the link still navigates normally and the
         click is still recorded. */
      this.list.addEventListener("click", (event) => {
        const item = event.target.closest("[data-bubbles-handle]");
        if (!item) return;
        /*item.toggleAttribute("data-bubbles-viewed", true);*/
        item.toggleAttribute("data-bubbles-viewed", false);
        markViewed(item.getAttribute("data-bubbles-handle"));
      });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.updateEdge);
    }

    /* The page HTML is cached and shared between shoppers, so it always
       arrives with every bubble unvisited. Paint the visited ones here. */
    restoreViewed() {
      const seen = readViewed();
      if (!seen.size) return;
      this.list.querySelectorAll("[data-bubbles-handle]").forEach((item) => {
        if (seen.has(item.getAttribute("data-bubbles-handle"))) {
          /*item.toggleAttribute("data-bubbles-viewed", true);*/
          item.toggleAttribute("data-bubbles-viewed", false);
        }
      });
    }

    /* Arrows hide once the rail can't travel any further that way, and stay
       hidden entirely when no bubble is actually cut off. Scrollable width
       worth no more than the trailing padding means every bubble is already
       fully in view, so an arrow there would have nothing to reveal. */
    updateEdge() {
      const slack = this.list.scrollWidth - this.list.clientWidth;
      const tail = parseFloat(getComputedStyle(this.list).paddingRight) || 0;
      if (slack <= tail + 1) {
        this.toggleAttribute("data-bubbles-edge-left", true);
        this.toggleAttribute("data-bubbles-edge-right", true);
        return;
      }
      this.toggleAttribute("data-bubbles-edge-left", this.list.scrollLeft <= 1);
      this.toggleAttribute(
        "data-bubbles-edge-right",
        this.list.scrollLeft + this.list.clientWidth >=
          this.list.scrollWidth - 1,
      );
    }

    page(dir) {
      this.list.scrollTo({
        left: this.list.scrollLeft + dir * this.list.clientWidth,
        behavior: "smooth",
      });
    }
  }

  if (!customElements.get("collection-bubbles")) {
    customElements.define("collection-bubbles", CollectionBubbles);
  }
})();
